module.exports = __webpack_public_path__ + "img/Execute.ac2e45c1.svg";